import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import jwt_decode from "jwt-decode";
import { AuthenticationService } from '../../core/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersRoleService } from '../user-role/users-role.service';
import { LoginapiService } from '../../auth/loginapi.service';
import { FleetService } from 'src/app/pages/managefleets/fleet-service/fleet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

export class TopbarComponent implements OnInit {
  selectedType: any;
  loginUserDetail: any
  loginUser: any;
  enable: boolean = true;
  disable:boolean = true;
  mainData: boolean = true;
  user: any;
  multiRoles: any;
  userRoleResponse: any;
  loginResponse: any;
  dataLoginName: any;
  selectUserData:any =[]
  consumerData:any = {
  opentype:[{name:'A***a',value:'Azuga'},{name:'R*******m',value:'IMT Insurance'},{name:'Bl*******y',value:'Blackberry'},{name:'Pi****r',value:'Pioneer'},{name:'A***m',value:'Axiom'},{name:'C*******h',value:'Clearpath'},{name:'I***x',value:'Inrix'}],
  provider:[{name:'S******s',value:'stellantis'},{name:'F**d',value:'ford'},{name:'T*****a',value:'toyota'},{name:'N*****n',value:'nissan'},{name:'V********e',value:'voyomotive'}],
}
  userDash: any;
  changeRole: boolean;
  customConsumer: any;
  imageUrl: any;
  imageUrlSmall: any;
  preview: any;
  constructor(@Inject(DOCUMENT) private document: any, private loginapiservice: LoginapiService, 
  private modalService: NgbModal, private _userRole: UsersRoleService, private router: Router, private authService: AuthenticationService,private fleetService:FleetService,private spinner:NgxSpinnerService,
  private sanitizer: DomSanitizer,private toastr : ToastrService) { 
        this.getLogo()
  }
  openMobileMenu: boolean;
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  selectedImage: any = null;
  ngOnInit() {
    this.openMobileMenu = false;
    this.loginUserDetail = sessionStorage.getItem('user-token');
    this.showRole();
    this.decodeToken()
  }

  faqbtn(){
    this.router.navigate(['adlp/managefleets/frequentlyAsked']); 
  }

  testAPI(){
    this.router.navigate(['adlp/managefleets/remoteAPITests']); 
  }

isDisabledUser(): boolean {
  return this.customConsumer !== 'Standard Fleet' && this.customConsumer !== 'SoraXpress' && this.customConsumer !== 'Smallboard';
}

get disableMessage(): string {
  return this.isDisabledUser() ? "Please contact sales to enable" : "";
}

  // onFileSelected(event: any): void {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       this.selectedImage = e.target?.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  getLogo() {
    this.spinner.show()
    this.fleetService.getImage().subscribe((res:any)=>{
      let result = res;
      this.imageUrl = result?.logoUrl
      const currentUrl = window.location.href;
      if (currentUrl.includes('azuga-tsp.fleetready.ai')) {
         this.imageUrlSmall = './assets/images/123.png';
      }
     else if (currentUrl.includes('guidepoint-tsp.fleetready.ai')) {
      this.imageUrlSmall = './assets/images/guidepoint-small.png';
   }
   else if (currentUrl.includes('hdfleet-tsp.fleetready.ai')) {
    this.imageUrlSmall = './assets/images/hdfleet-small.png';
 }
 else if (currentUrl.includes('forwardthinking-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/forward-small.png';
}
else if (currentUrl.includes('smallboard-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/sirius-small.png';
}
else if (currentUrl.includes('siriusxm-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/sirius-small.png';
}
else if (currentUrl.includes('dpltelemetics-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/dpl-small.png';
}
else if (currentUrl.includes('orionfi-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/orion-small.png';
}
else if (currentUrl.includes('btracking-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/btracking-small.png';
}
else if (currentUrl.includes('standardfleet-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/standard-small.png';
}
else if (currentUrl.includes('gpstrackit-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/gps-small.png';
}
else if (currentUrl.includes('onwardconnected-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/onward-small.png';
}
else if (currentUrl.includes('assetworks-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/asset-small.png';
}
else if (currentUrl.includes('mastrack-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/mastrack-small.png';
}
else if (currentUrl.includes('soraxpress-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/soraxpresslogo.png';
}
else if (currentUrl.includes('razortracking-tsp.fleetready.ai')) {
  this.imageUrl = './assets/images/razor-logo.png';
}
else if (currentUrl.includes('cerebrumx-tsp.fleetready.ai')) {
  this.imageUrlSmall = './assets/images/cx-small.png';
}
else if (currentUrl.includes('westcoastgps-tsp.fleetready.ai')) {
  this.imageUrl = './assets/images/Westcoast-logo.png';
}
else if (currentUrl.includes('fleetready.ai')) {
  this.imageUrlSmall = './assets/images/cx-small.png';
}
else if (currentUrl.includes('localhost:4200')) {
  this.imageUrlSmall = './assets/images/soraxpresslogo.png';
}
      setTimeout(()=>{
        this.spinner.hide()
      },1000)
    },err=>{
      this.spinner.hide()
    })
  }

  closeModal() {
    this.preview = null;
    this.selectedImage = null
  }

  onFileSelected(event: any): void {
    const files1 = event.target.files;
    if (files1.length > 0) {
      let file: File = event.target.files.item(0);
        this.selectedImage =file
        // console.log(this.selectedImage,'imagegge')
        const reader = new FileReader();

      reader.onload = (e: any) => {
        // console.log(e.target.result);
        this.preview = e.target.result;
        this.preview = this.sanitizer.bypassSecurityTrustUrl(this.preview)
      };

      reader.readAsDataURL(this.selectedImage);
    }
  }

  requestSent(deleteConsumerData) {
    if(this.user != "role_consumer") {
      this.modalService.open(deleteConsumerData, { size: 'sx', centered: true });

    }    
  }

  changeLogo() {
    this.spinner.show()
    this.fleetService.uploadImage(this.selectedImage).subscribe((res:any)=>{
      this.selectedImage = null
      this.preview = null;
      this.getLogo()
      this.spinner.hide()
    },err=>{
      this.toastr.error(err.error.apierror.message)
      this.spinner.hide()
    })
  }


  showRole() {
    let userRolLogin = JSON.stringify(sessionStorage.getItem('userRole'));
    this.user = JSON.parse(userRolLogin);
    let tspuserData = JSON.parse(sessionStorage.getItem('Useremail'))
    let tspEmail = tspuserData?.email
    if (tspEmail == 'smccurdy@hdfleet.com') {
      this.enable = true
      this.disable = false;
      this.mainData = false;
    }
    else if(tspEmail == 'adam@onestepgps.com'){
      this.disable = true;
      this.enable = false;
      this.mainData = false
    }
    else{
      this.disable = false;
      this.enable = false;
      this.mainData = true;
    }
    this.multiRoles = JSON.parse(sessionStorage.getItem('multiRole'));
    let customConsumers =JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer=JSON.parse(customConsumers); 
  }

  openModal(content: any) {
    this.modalService.open(content);
  }

  isMenuOpen = false; // Track menu state

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.isMenuOpen = !this.isMenuOpen; // Toggle state
    this.mobileMenuButtonClicked.emit(this.isMenuOpen);
  }

  logout() {
    let userdata = JSON.parse(this.loginUserDetail);
    let token = userdata.accessToken;
    const logoutToken: any = {
      accessToken: token
    }
    this.authService.logOut(logoutToken);
  }
  decodeToken() {
    var userdetail = JSON.parse(this.loginUserDetail)
    if (userdetail)
      var token = userdetail.idToken;
    this.loginUser = jwt_decode(token);
  }

  datapihub() {
    this.router.navigate(['adlp/developer-corner/dataapihub']);
  }

  cxtaxonomy() {
    this.router.navigate(['adlp/developer-corner/cerebrumx-taxonomy'])
  }

  createcustommodel() {
    this.router.navigate(['adlp/developer-corner/custom-model'])
  }

  vindecoder(){
    this.router.navigate(['adlp/developer-corner/generatereports'])
  }

  tripsimulator(){
    this.router.navigate(['adlp/developer-corner/trip-simulator'])
  }

  configuration(){
    this.router.navigate(['adlp/insurance/configuration'])
  }

  onChange(event) {
    this.selectedType = event.target.value;
    if(this.selectedType == 'provider') {
      this.changeRole = true;
      this.selectUserData = this.consumerData.provider
    } else if(this.selectedType == 'admin') {
      this.changeRole = false;
      this.selectUserData = this.consumerData.admin
    } else {
      this.changeRole = true;
      this.selectUserData = this.consumerData.opentype
    }
  }

  support(){
    this.router.navigate(['adlp/support'])
  }

  selectDashboard(evt) {
    this.userDash = evt;
  }

  largeModal3(support: any) {
    this.modalService.open(support, { size: 'sl', centered: true });
  }
}
